import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      retryCount: 0
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[Widget] Error caught by boundary:', error, errorInfo);
    this.setState({ errorInfo });
    
    // Log to external service in production
    if (process.env.NODE_ENV === 'production') {
      // TODO: Send to error tracking service
      console.error('Production error:', { error: error.message, stack: error.stack, errorInfo });
    }
  }

  handleRetry = () => {
    this.setState(prevState => ({
      hasError: false,
      error: null,
      errorInfo: null,
      retryCount: prevState.retryCount + 1
    }));
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const { error, retryCount } = this.state;
      const isRetryable = retryCount < 3;

      return (
        <div className="ov-error-boundary" role="alert" aria-live="polite">
          <div className="ov-error-boundary-content">
            <div className="ov-error-icon" aria-hidden="true">⚠️</div>
            <h2 className="ov-error-title">Something went wrong</h2>
            <p className="ov-error-message">
              We encountered an unexpected error. {isRetryable ? 'You can try again or reload the page.' : 'Please reload the page.'}
            </p>
            
            {process.env.NODE_ENV === 'development' && error && (
              <details className="ov-error-details">
                <summary>Error Details (Development Only)</summary>
                <pre className="ov-error-stack">
                  {error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
            
            <div className="ov-error-actions">
              {isRetryable && (
                <button 
                  className="ov-error-retry-btn"
                  onClick={this.handleRetry}
                  aria-label="Try again"
                >
                  Try Again
                </button>
              )}
              <button 
                className="ov-error-reload-btn"
                onClick={this.handleReload}
                aria-label="Reload the page"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
